import PreviewFrame from '../PreviewFrame';
import SplashLoginCard from '../SplashLoginCard';

const MessagesPreview = ({
  devicePreview,
  editable,
  selectedLanguage,
  selectedMessageId,
  onSelectMessage,
  onUpdateMessageStyle,
  messages,
  onUpdateMessagesBlock,
  languageOptions,
  setLanguageOptions,
  login,
  onUpdateLoginBlock,
  imageInfo,
  onUpdateImageBlock,
}) => {
  const isMobile = devicePreview === 'mobile';
  const selectedMessage = messages.find(item => item.id === selectedMessageId);

  return (
    <PreviewFrame
      devicePreview={devicePreview}
      languageOptions={languageOptions}
      setLanguageOptions={setLanguageOptions}
      selectedLanguage={selectedLanguage}
      editable={editable}
      imageInfo={imageInfo}
      onUpdateImageBlock={onUpdateImageBlock}
    >
      <SplashLoginCard
        isMobile={isMobile}
        imageInfo={imageInfo}
        login={login}
        editable={editable}
        onUpdateImageBlock={onUpdateImageBlock}
        onUpdateLoginBlock={onUpdateLoginBlock}
        onUpdateMessagesBlock={onUpdateMessagesBlock}
        selectedMessage={selectedMessage}
        onUpdateMessageStyle={onUpdateMessageStyle}
        onSelectMessage={onSelectMessage}
      />
    </PreviewFrame>
  );
};

export default MessagesPreview;
